/**
 * Hook that fires a PAGE_VIEWED event on every route change.
 */

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Events } from '@danny-tasks/shared/telemetry';
import { useTrackEvent } from './hooks';

/**
 * Tracks page views by listening to react-router location changes.
 * Should be rendered once, near the top of the component tree (inside the router).
 */
export function usePageTracking(): void {
  const location = useLocation();
  const track = useTrackEvent();
  const prevPath = useRef<string | null>(null);

  useEffect(() => {
    // Avoid duplicate fire on first render when path hasn't changed.
    if (prevPath.current === location.pathname) return;
    prevPath.current = location.pathname;

    track(Events.PAGE_VIEWED, {
      path: location.pathname,
      referrer: document.referrer || undefined,
    });
  }, [location.pathname, track]);
}
